import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Radio,
} from '@mui/material';
import SortIcon from '@mui/icons-material/Sort';
import { useFilePlayerContext } from '../FilePlayerContext';
import { GROUPBY_DATE, GROUPBY_ADVISOR } from '../filePlayerConstants';

export const FileSortButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { currentView, setCurrentView, groupBy, setGroupBy } = useFilePlayerContext();

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton onClick={handleOpen}>
        <SortIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem>
          <ListItemText primary="View" />
        </MenuItem>

        <MenuItem onClick={() => { setCurrentView('all'); handleClose(); }}>
          <ListItemIcon><Radio checked={currentView === 'all'} /></ListItemIcon>
          <ListItemText primary="All Files" />
        </MenuItem>

        <MenuItem onClick={() => { setCurrentView('trash'); handleClose(); }}>
          <ListItemIcon><Radio checked={currentView === 'trash'} /></ListItemIcon>
          <ListItemText primary="Trash" />
        </MenuItem>

        <Divider />

        <MenuItem>
          <ListItemText primary="Group by" />
        </MenuItem>

        <MenuItem onClick={() => { setGroupBy(GROUPBY_DATE); handleClose(); }}>
          <ListItemIcon><Radio checked={groupBy === GROUPBY_DATE} /></ListItemIcon>
          <ListItemText primary="Date" />
        </MenuItem>

        <MenuItem onClick={() => { setGroupBy(GROUPBY_ADVISOR); handleClose(); }}>
          <ListItemIcon><Radio checked={groupBy === GROUPBY_ADVISOR} /></ListItemIcon>
          <ListItemText primary="Flirt" />
        </MenuItem>

        <MenuItem onClick={() => { setGroupBy(null); handleClose(); }}>
          <ListItemIcon><Radio checked={!groupBy} /></ListItemIcon>
          <ListItemText primary="None" />
        </MenuItem>
      </Menu>
    </>
  );
};
